import Call from './ActivityOutcomeDialog/pages/Call';
import DefaultExtensionData from './ActivityOutcomeDialog/pages/DefaultExtensionData';
import Dossier from './ActivityOutcomeDialog/pages/Dossier';
import CallItem from './ActivityOutcomeItem/DetailsDialog/pages/Call';
import DefaultDialogContent from './ActivityOutcomeItem/DetailsDialog/pages/DefaultExtensionData';
import DossierItem from './ActivityOutcomeItem/DetailsDialog/pages/Dossier';
import ManualExtensionData from './ActivityOutcomeDialog/pages/Manual';

export const EXTENSION_DATA_FORM = {
  CALL: Call,
  SMS: DefaultExtensionData,
  EMAIL: DefaultExtensionData,
  APPOINTMENT: DefaultExtensionData,
  DOSSIER: Dossier,
  'MASSIVE-SMS': DefaultExtensionData,
  MANUAL: ManualExtensionData,
};

export const EXTENSION_DATA_DETAILS = {
  CALL: CallItem,
  SMS: DefaultDialogContent,
  EMAIL: DefaultDialogContent,
  APPOINTMENT: DefaultDialogContent,
  DOSSIER: DossierItem,
  'MASSIVE-SMS': DefaultDialogContent,
  MANUAL: DefaultDialogContent,
};
